import { NgModule }             from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagedByMeComponent } from './managed-by-me.component';

const routes: Routes = [{
  path: '', component: ManagedByMeComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagedByMeRoutingModule {
}
